export interface CardButton {
  title?: string;
  icon?: string;
  class?: string;
  actionKey: string;
  actionType?: string;
  actionData?: any;
}
